/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for events log search:
 *   * ALL : All fields (DATE, TAG, DESCRIPTION, VALUE)
 *   * DATE : the date field
 *   * TAG : The tag field
 *   * DESCRIPTION : The tag description field
 *   * VALUE : The value field
 *   * IS_ALARM
 */
export enum EventLogSearchFilter {
  ALL = 'ALL',
  DATE = 'DATE',
  TAG = 'TAG',
  DESCRIPTION = 'DESCRIPTION',
  VALUE = 'VALUE',
  IS_ALARM = 'IS_ALARM'
}
